import { CoverageStrip } from './CoverageStrip';

export function CoveragePanel({ coverage }: { coverage: Array<{ account_mask?: string; row_count?: number; months?: Array<{ ym: string; status: string }> }> }) {
  return (
    <section className="rounded-[10px] border border-border bg-card p-4" aria-labelledby="coverage-heading">
      <h2 id="coverage-heading" className="font-semibold">1. Coverage</h2>
      {coverage.length === 0 ? <p className="mt-2 text-sm text-muted-foreground">No business rows shared yet.</p> : coverage.map((account) => (
        <div key={account.account_mask} className="mt-3 text-sm">
          <div className="flex justify-between"><span>{account.account_mask}</span><span className="text-muted-foreground">{account.row_count ?? '—'} rows</span></div>
          <CoverageStrip months={account.months ?? []} />
          <p className="mt-1 text-xs text-muted-foreground">Business rows shared for review.</p>
        </div>
      ))}
      <p className="mt-3 text-xs text-muted-foreground">Not shared: personal accounts. Coverage cannot certify unseen accounts.</p>
    </section>
  );
}

export default CoveragePanel;
